import validatorBuilder from 'validator-builder';

let inventaireStockFormValidator = null;

export default class InventaireStockForm {
	constructor(data) {
		data = data || {};
		this.idInventaire = data.idInventaire || null;
		this.libelle = data.libelle || null;
		this.idSociete = data.idSociete || null;
		this.societe = data.societe || null; // libellé de la Société
		this.idGroupeSite = data.idGroupeSite || null;
		this.groupeSite = data.groupeSite || null; // libellé du Site Commercial
		this.auteur = data.auteur || null; // prénom et nom de l'auteur
		this.dateLevee = data.dateLevee || null;
		this.commentaire = data.commentaire || null;
		// this.dateIntegration = data.dateIntegration || null;
		this.idEltNiv1 = data.idEltNiv1 || null;
		this.eltNiv1 = data.eltNiv1 || null;
		this.libelleEltNiv1 = data.libelleEltNiv1 || null;

		this.produits = data.produits;
		this.historiques = data.historiques;
		this.isClotured = data.isClotured || false;
		this.dateCloture = data.dateCloture || null;
	}

	isValid() {
		inventaireStockFormValidator = inventaireStockFormValidator || validatorBuilder.getInstanceFor('InventaireStockForm');
		const validationResults = inventaireStockFormValidator.validate(this);
		return validationResults.isValid;
	}
}
